import { library } from '@fortawesome/fontawesome-svg-core'
import { faDrone, faSortShapesUp, faWindowFrameOpen, faTasks } from '@fal'
library.add(faDrone, faSortShapesUp, faWindowFrameOpen, faTasks)